// AUTO-GENERATED by scripts/fetch-cms-content.mjs (DIT-264 / S9).
// Gitignored — do NOT edit or commit. Empty objects mean "use baked EUR".
/* eslint-disable */
export const CMS_PRICING: {
  prices: Record<string, Record<string, { base: number; user: number }>>;
  currencyByCountry: Record<string, string>;
  localeToCountry: Record<string, string>;
  defaultCountry: string;
} = {
  "prices": {
    "eur": {
      "project_basic": {
        "base": 55,
        "user": 4.99
      },
      "project_pro": {
        "base": 55,
        "user": 6.99
      },
      "time_basic": {
        "base": 10,
        "user": 2.99
      },
      "time_pro": {
        "base": 10,
        "user": 4.99
      }
    }
  },
  "currencyByCountry": {
    "be": "eur",
    "int": "usd",
    "lt": "eur"
  },
  "localeToCountry": {
    "nl": "be",
    "fr-be": "be",
    "en-be": "be",
    "en": "int",
    "es": "int",
    "de": "int",
    "it": "int",
    "pt": "int",
    "pl": "int",
    "ro": "int",
    "no": "int",
    "bg": "int",
    "tr": "int",
    "lt": "lt"
  },
  "defaultCountry": "be"
};
